import React, {useState} from "react";
import {Box, Button, Dialog, DialogTitle, Typography} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import CustomAlert from "../common/CustomAlert";
import {IUpdateBody} from "../../store/rtk-api/daily_reconciliations/types";

type PropsType = {
    recId: number | null
    isWindowOpen: boolean,
    isLoading: boolean,
    isError: boolean,
    isSuccess: boolean,
    closeWindow(): void,
    handlePerform(body: IUpdateBody): void,
    status: boolean,
    patientName: string
    patientPhone: string
    date: string
    doctorName: string
    doctorPhoto: string

}

const DailyReconciliationWindow: React.FC<PropsType> = ({
                                                            isWindowOpen,
                                                            isLoading,
                                                            isError,
                                                            isSuccess,
                                                            closeWindow,
                                                            handlePerform,
                                                            status,
                                                            patientName,
                                                            patientPhone, date, doctorName, doctorPhoto, recId

                                                        }) => {
    const [isAlert, setAlert] = useState(false)
    const handleClose = () => {
        closeWindow()
        setAlert(false)
    }
    const handlePerformFunction = (visitStatus: number) => {
        setAlert(true)
        handlePerform({
            id: recId,
            body: {
                visited: visitStatus
            }
        })
    }
    return (
        <Dialog
            open={isWindowOpen}
            sx={{
                // overflowX: "hidden"
            }}
        >
            {isLoading && <CircularProgress/>}
            {isError && isAlert && <CustomAlert title="Ошибка" status="error" message={"Что то пошло не так"}/>}
            {isSuccess && isAlert && <CustomAlert title="Успех" status="success" message="Операция успешно выполнено"/>}
            <DialogTitle id="alert-dialog-title">
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    // overflowX: "hidden"
                }}>


                    <CloseIcon sx={{cursor: 'pointer'}} onClick={handleClose}/>
                </Box>

                <Box sx={{
                    minWidth: "400px",
                    p: "20px",
                    // display: "flex",
                    // overflow: "hidden"
                }}>
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        mb: "20px"
                    }}>
                        <div>
                            <img
                                src={doctorPhoto}
                                alt="" style={{width: "50px", height: "50px", borderRadius: "50px"}}/>
                        </div>
                        <div>
                            <Typography sx={{fontSize: "15px"}}>{doctorName}</Typography>
                            {/*<Typography sx={{fontSize: "14px", color: "gray"}}>Окулист (офтальмолог)</Typography>*/}
                        </div>
                    </Box>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        mb: "20px"
                    }}>

                        <Typography sx={{fontSize: "15px"}}>Имя пациента: {patientName}</Typography>
                        <Typography sx={{fontSize: "15px"}}>Номер пациента: {patientPhone}</Typography>
                        <Typography sx={{fontSize: "15px"}}>Дата записи: 1 авг. {date}</Typography>
                    </Box>

                    <Box>
                        {!status && <Button variant="outlined"
                                            size="large"
                                            sx={{mb: "20px", textTransform: 'capitalize', border: "1px solid green"}}
                                            onClick={() => handlePerformFunction(1)}
                                            fullWidth
                                            color={"success"}
                        >
                            Посетил
                        </Button>}
                        {status && <Button variant="outlined"
                                           size="large"
                                           sx={{mb: "20px", textTransform: 'capitalize', border: "1px solid red"}}
                                           onClick={() => handlePerformFunction(0)}
                                           fullWidth
                                           color={"error"}
                        >
                            Не посетил
                        </Button>}
                        {/*<Button variant="outlined"*/}
                        {/*        size="large"*/}
                        {/*        sx={{mb: "20px", textTransform: 'capitalize', border: "1px solid gray", color:"gray"}}*/}
                        {/*        onClick={handlePerformFunction}*/}
                        {/*        fullWidth*/}
                        {/*>*/}
                        {/*    Перезаписать*/}
                        {/*</Button>*/}

                    </Box>

                </Box>

            </DialogTitle>
        </Dialog>
    )
}

export default DailyReconciliationWindow